import { CgClose, CgSearch } from 'react-icons/cg';
import { Icon, IconProps } from '@chakra-ui/react';

import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';
import { Input, InputProps } from './Input.component';

type SearchInputProps = Omit<InputProps, 'startElement' | 'endElement'> & {
  iconPosition?: 'end' | 'start';
  iconProps?: IconProps;
};

export const SearchInput: FormFieldControlledComponent<
  string,
  SearchInputProps
> = ({
  name,
  iconPosition = 'end',
  iconProps,
  onChange,
  value,
  ...props
}: FormFieldControlledComponentProps<string, SearchInputProps>) => {
  const hasValue = !!value;

  const clearInput = (): void => onChange('');

  const inputIconProps = {
    [`${iconPosition}Element`]: <Icon as={CgSearch} {...iconProps} />,
    ...(hasValue && {
      endElement: (
        <Icon
          as={CgClose}
          {...iconProps}
          cursor="pointer"
          onClick={clearInput}
        />
      ),
    }),
  };

  return (
    <Input
      id={name}
      {...inputIconProps}
      name={name}
      onChange={onChange}
      value={value}
      {...props}
    />
  );
};

SearchInput.controlled = true;
SearchInput.displayName = 'SearchInput';
